var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportCorner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 457,
    viewBox: "0 0 278 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.8318 219.65C43.714 219.65 102.524 278.4 102.524 350.871C102.524 423.343 43.714 482.093 -28.8318 482.093C-101.378 482.093 -160.187 423.343 -160.187 350.871C-160.187 278.4 -101.378 219.65 -28.8318 219.65Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.3611 168.949C20.1847 168.949 78.9943 227.699 78.9943 300.17C78.9943 372.641 20.1847 431.391 -52.3611 431.391C-124.907 431.391 -183.716 372.641 -183.716 300.17C-183.716 227.699 -124.907 168.949 -52.3611 168.949Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.99 132.081C43.5558 132.081 102.365 190.831 102.365 263.302C102.365 335.773 43.5558 394.524 -28.99 394.524C-101.536 394.524 -160.345 335.773 -160.345 263.302C-160.345 190.831 -101.536 132.081 -28.99 132.081Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCorner2);
export default __webpack_public_path__ + "static/media/report_corner_2.8a9ed1ba0f4c5b2f02f9e854bd9b8d39.svg";
export { ForwardRef as ReactComponent };